<template>
	<div v-bind:id="anchor" class="widgetAdvancedSearchItems">
		<div class="widgetAdvancedSearchItems__inner">
			<h3 class="widgetAdvancedSearchItems__heading">
				<template v-if="collapse">
					<a v-bind:href="collapsetarget" v-bind:class="{'collapsed': collapse}" data-toggle="collapse"><slot name="heading"></slot></a>
				</template>
				<template v-else>
					<span><slot name="heading"></slot></span>
				</template>
			</h3>
			<div v-bind:id="collapseid" v-bind:class="{'collapse': collapse}" class="widgetAdvancedSearchItems__content">
				<div class="widgetAdvancedSearchItems__contentInner">
					<slot name="content"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {
	props: {
		anchor: '',
		collapse: {
			type: Boolean,
			default: true
		},
		collapseid: {
			type: String,
			required: true
		}
	},
	data: function(){
		return {
			collapsetarget: ''
		};
	},
	created: function(){
		this.collapsetarget = '#' + this.collapseid;
	}
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// widget_advanced_search_items.vue?012a1cc0